// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductItem_item__DjZuC","price":"ProductItem_price__35pmZ","actions":"ProductItem_actions__xYrNc"};